export default {
  app: {
    featured: '精选',
    random: '随机',
    explore: '探索',
    keywords: '关键词',
    search: '搜索',
  },
  explore: {
    filters: '筛选',
    resetFilters: '重置筛选',
    addKeyword: '添加关键字',
  },
  recipe: {
    contributedBy: '贡献者',
    ingredients: '用料',
    directions: '步骤',
    fullRecipe: '查看完整配方',
    similarDrinks: '类似的饮料',
  },
  featuredRecipes: {
    loadMore: '加载更多',
  },
  recipeFind: {
    filterBy: '筛选条件',
    name: '名称',
    ingredients: '用料',
    keywords: '关键词',
    searchForIngredients: '您可以用空格分隔多个用料在搜索里',
    searchForKeywords: '您可以用空格分隔多个关键字在搜索里',
  },
  recipeList: {
    viewRecipe: '查看配方',
  },
  recipeToolbar: {
    print: '打印',
    share: '分享',
    shareOnFacebook: 'Facebook',
    shareOnTwitter: 'Twitter',
    copyURL: '复制链接',
    hideImage: '隐藏图像',
  },
  favorites: {
    removeAllFavorites: '删除所有收藏里的饮料',
    noFavoriteDrinks: '您没有收藏的饮料',
    removeFavoritesPrompt: '您确定要删除所有收藏里的饮料么？',
    delete: '删除',
    cancel: '取消',
  },
  keywordList: {
    enterYourKeyword: '输入关键字',
  },
  search: {
    findYourDrink: '找想要的饮料',
  },
  pageNotFound: {
    pageNotFound: '未找到您要查找的页面。',
    backToHome: '返回首页',
  },
};
